import * as adminTypes from './adminTypes';

const initialState = {
  cmsUploads: {
    files: [],
  },
  dropDowns: {
    fileCategory: [],
    packageTypes: [],
    yearTypes: [],
    years: [],
  },
  fileCategory: [],
  fileCategoryProps: {},
  packageId: null,
  filters: {
    packageTypes: [],
    years: [],
    yearTypes: [],
    statuses: [],
    totalErrors: [],
    fileTypes: [],
  },
  tableData: null,
  showFilterModal: false,
  errorMsg: null,
  powerBiDetails:null
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminTypes.GET_CMS_FILES_SUCCESS: {
      return { ...state, tableData: action.payload };
    }
    case adminTypes.SET_CMS_PACKAGE_ID:
      return { ...state, packageId: action.data, errorMsg: null };
    case adminTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl,
      };
    case adminTypes.GET_CMS_DROPDOWNS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };
    case adminTypes.GET_CMS_UPLOAD_DROPDOWNS_SUCCESS:
      return {
        ...state,
        dropDowns: {
          fileCategory: action.data.fileCategory,
          packageTypes: action.data.packageTypes,
          yearTypes: action.data.yearTypes,
          years: action.data.years,
        },
        errorMsg: null,
      };
    case adminTypes.GET_CMS_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: action.data,
      };
    case adminTypes.CLEAR_CMS_ERROR_MESSAGE:
      return { ...state, errorMsg: null };
    case adminTypes.GET_DROPDOWN_VALUES_FOR_FILE_CATEGORY:
      return {
        ...state,
        fileCategoryProps: action.data.fileCategory,
        errorMsg: null,
      };
    case adminTypes.GET_DROPDOWN_VALUES_FOR_FILE_CATEGORY:
      return {
        ...state,
        fileCategory: action.data.fileCategory,
        errorMsg: null,
      };
    case adminTypes.RESET_CMS_STATE:
      return {
        ...initialState
      };
    case adminTypes.GET_POWERBI_DETAILS:
        return {
          ...state,
          powerBiDetails: action.data.message,
        };
    case adminTypes.GET_POWERBI_DETAILS_FAILURE:
          return {
            ...state,
            powerBiDetails: action.data.message,
          };  
    case adminTypes.CLEAR_POWERBI:
        return {
              ...state,
              powerBiDetails: null,
      };             
    default:
      return state;
  }
};

export { initialState };
export default adminReducer;
